/**
 * The OS-level "reduce motion" preference, read at render time.
 *
 * Lives here rather than next to its first caller (the WebGL veil) because the dashboard's stat
 * tiles need it too, and importing it from `DarkVeil` would pull a shader into every chunk that
 * renders a number.
 */
export function prefersReducedMotion(): boolean {
  // matchMedia is absent in jsdom unless stubbed, and in very old browsers.
  return typeof window.matchMedia === 'function' && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
}
